import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPinterestP,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import logo from '../../assets/images/logo.png';
import './Footer.css';

const FooterNavLink = ({ to, children }) => {
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === to) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    window.setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  return (
    <Link to={to} onClick={handleClick}>
      {children}
    </Link>
  );
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="footer__grid">
            {/* Brand column */}
            <div className="footer__col footer__col--brand">
              <FooterNavLink to="/">
                <img src={logo} alt="Digi Rasa" className="footer__logo" />
              </FooterNavLink>
              <p className="footer__desc">
                Explore our menu and enjoy modern-style traditional cuisine with Digirasa.
              </p>
              <div className="footer__contact-items">
                <div className="footer__contact-item">
                  <FaMapMarkerAlt />
                  <span>Plot No-HIG-137, Mayurinagar, Miyapur, Hyderabad- 500049</span>
                </div>
                <div className="footer__contact-item">
                  <FaPhone />
                  <a href="tel:+918143231857">+91 81432 31857</a>
                </div>
                <div className="footer__contact-item">
                  <FaEnvelope />
                  <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
                </div>
              </div>
            </div>

            {/* Working Hours */}
            <div className="footer__col footer__col--hours">
              <h4 className="footer__heading">WORKING</h4>
              <p className="footer__hours-compact">
                Open daily <strong>11:00 – 22:00</strong>
              </p>
              <ul className="footer__hours">
                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(
                  (day) => (
                    <li key={day}>
                      <span className="footer__day">{day}</span>
                      <span className="footer__time">11:00 – 22:00</span>
                    </li>
                  ),
                )}
              </ul>
            </div>

            {/* Help Links */}
            <div className="footer__col footer__col--help">
              <h4 className="footer__heading">HELP</h4>
              <ul className="footer__links">
                <li>
                  <FooterNavLink to="/refund_returns">Refund &amp; Cancellation</FooterNavLink>
                </li>
                <li>
                  <FooterNavLink to="/privacy-policy">Privacy Policy</FooterNavLink>
                </li>
                <li>
                  <FooterNavLink to="/terms-and-conditions">Terms &amp; Conditions</FooterNavLink>
                </li>
                <li>
                  <FooterNavLink to="/faq">FAQ</FooterNavLink>
                </li>
              </ul>
            </div>

            {/* Social */}
            <div className="footer__col footer__col--contact">
              <h4 className="footer__heading">GET IN TOUCH</h4>
              <div className="footer__social">
                <a
                  href="https://www.youtube.com/@Digirasa"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </a>
                <a
                  href="https://www.instagram.com/p/DE1mGs3JH_S/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.facebook.com/people/DigiRasa/61574968622139/#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://in.pinterest.com/digirasa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Pinterest"
                >
                  <FaPinterestP />
                </a>
              </div>
              <div className="footer__app-badges">
                <p className="footer__app-text">Download Our App</p>
                <div className="footer__app-badge-row">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.digirasa.client"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require('../../assets/images/google-play.png')}
                      alt="Get it on Google Play"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/in/app/digirasa/id6736368836"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require('../../assets/images/app-store.png')}
                      alt="Download on the App Store"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__quicklinks-row">
            <ul className="footer__quicklinks-inline">
              <li>
                <FooterNavLink to="/">Home</FooterNavLink>
              </li>
              <li>
                <FooterNavLink to="/about-us">About Us</FooterNavLink>
              </li>
              <li>
                <FooterNavLink to="/reviews">Reviews</FooterNavLink>
              </li>
              <li>
                <FooterNavLink to="/our-menu">Our Menu</FooterNavLink>
              </li>
              <li>
                <FooterNavLink to="/services">Services</FooterNavLink>
              </li>
              <li>
                <FooterNavLink to="/whychooseus">Why Choose Us</FooterNavLink>
              </li>
              <li>
                <FooterNavLink to="/contact">Contact</FooterNavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <p>© 2026 Bulusu Digital Innovations Pvt. Ltd., All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
